import './tabs-carousel';
// import './tabs-carousel-brands';

// init tabs after all other js
import './tabs-init';
